module.exports = __webpack_public_path__ + "img/appLogo.8af36a59.png";